import { curry, includes } from 'ramda';

import { lowerAll, safeLower } from './lowercase.js';

/**
 * Checks if a string `value` is present in in a list of `words`.
 * The comparison between elements is case insensitive.
 * @example
 *  isOneOf(['carrot', 'cucumber', 'parsnip'], 'tuna') // false
 * @see https://ramdajs.com/docs/#includes
 */
const isOneOf = curry(
  /**
   * Checks if a string `value` is present in in a list of `words`.
   * The comparison between elements is case insensitive.
   * @param {string[]} words A list of words.
   * @param {string} value The value to check.
   * @returns {boolean} `true` if `value` is included in `words` (case insensitive);
   *  `false`, otherwise.
   */
  (words, value) => includes(safeLower(value), lowerAll(words))
);

export default isOneOf;
